const { HYDRATE } = require('next-redux-wrapper');

const { ActionTypeEnum } = require('redux/ActionTypeEnum');

const initialState = {
	searchCategories: [],
	homeCategories: [],
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case HYDRATE: {
			return { ...state, ...action.payload['categories'] };
		}

		case ActionTypeEnum.home_categories_success: {
			return {
				...state,
				homeCategories: action.payload,
			};
		}

		case ActionTypeEnum.search_categories_success: {
			return { ...state, searchCategories: action.payload };
		}

		default:
			return state;
	}
};
export { reducer as categories };
export * from './selectors';
